import { render, staticRenderFns } from "./client-codes-edit-tab.vue?vue&type=template&id=15fb70c6&scoped=true"
import script from "./client-codes-edit-tab.vue?vue&type=script&lang=js"
export * from "./client-codes-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./client-codes-edit-tab.vue?vue&type=style&index=0&id=15fb70c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fb70c6",
  null
  
)

export default component.exports